import { motion } from 'framer-motion';

export default function Logo() {
  return (
    <motion.div className="flex items-center gap-3 py-2">
      <div className="relative flex items-center justify-center w-10 h-10">
        <img
          src="./logo02.png"
          alt="UEA Trading Software logo"
          className="object-contain w-full h-full rounded-lg"
        />
      </div>
      <div className="flex flex-col leading-none">
        <span className="text-white font-black text-lg tracking-widest">UEA</span>
        <span className="text-[10px] tracking-[0.2em] font-medium" style={{ color: '#22c55e' }}>TRADING · SOFTWARE</span>
      </div>
    </motion.div>
  );
}
